/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicProfile } from '../models/PublicProfile';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssociationPublicProfileService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns PublicProfile
   * @throws ApiError
   */
  public findPublic(): CancelablePromise<PublicProfile> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/public-profile/{userId}/{associationUserId}',
    });
  }
}
